'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgIdcard(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M3.289 3.702l9.283-.002c.496 0 .676.052.858.149.182.097.324.24.421.421.097.182.149.362.149.858v5.715c0 .497-.052.677-.149.858-.097.182-.24.324-.421.422-.182.097-.362.148-.858.148H3.428c-.496 0-.676-.051-.858-.148a1.012 1.012 0 01-.421-.422c-.088-.163-.138-.325-.147-.718L2 5.128c0-.496.052-.676.149-.858.097-.182.24-.324.421-.421.163-.088.326-.138.719-.147zm9.51 1.2H3.2v6.168H12.8V4.901zM5.856 8.304c1.11 0 1.801.762 1.801 1.314 0 .169-.097.27-.382.288l-.102.003H4.54c-.364 0-.484-.103-.484-.29 0-.553.691-1.315 1.799-1.315zm4.373.11a.514.514 0 010 1.028H8.686a.514.514 0 110-1.029h1.543zM5.856 6.056c.457 0 .86.387.86.92 0 .536-.403.947-.86.947-.455 0-.857-.411-.857-.942 0-.528.402-.925.857-.925zm5.23.472a.514.514 0 010 1.028h-2.4a.514.514 0 010-1.028h2.4z", fill: "currentColor" }))));
}

module.exports = SvgIdcard;
//# sourceMappingURL=Idcard.js.map
